import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete, CardContent, Card, Modal, DialogTitle } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { Stack } from "@mui/material";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import styled from "styled-components";
import AddRoutePlan from "../../components/modals/addRoutePlan";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, getGridStringOperators } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import searchIcon from "../../icons/searchIcon.svg"
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";
import PartyList from "./partyListModal";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const TodayRoutePlanModal = ({ onClose, is_download }) => {
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dataGrid, setDataGrid] = useState([]);
    const [rowCount, setRowCount] = useState();
    const [endVisitRow, setEndVisitRow] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [endVisitModalOpen, setEndVisitModalOpen] = useState(false);
    const [newOrderStatus, setNewOrderStatus] = useState(0);
    const [visitModalData, setVisitModalData] = useState({});
    const [questionCategories, setQuestionCategories] = useState([]);
    const [openVisitViewModal, setOpenVisitViewModal] = useState(false);
    const [partyList, setPartyList] = useState([]);
    const [editModalData, setEditModalData] = useState({})
    const [openDialog, setOpenDialog] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: currentPage - 1,
        pageSize: 20,
    });
    const [modalData, setModalData] = useState()
    const [reason, setReason] = useState("");
    const [rejectData, setRejectData] = useState(null);
    const [editMode, setEditMode] = useState(false)
    const [modal, setModal] = useState(false)
    const [todayPunches, setTodayPunches] = useState([]);
    const [accessChanges, setAccessChanges] = useState([]);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [endVisitForm, setEndVisitForm] = useState({
        startMeetingTime: "",
        endMeetingTime: "",
        endVisitTime: "",
        remark: "",
        mobileNumber: "",
        contactName: "",
        statusOfVisit: "",
        workDone: "",
        productCategory: [],
        feedback: "",
    });
    const [errors, setErrors] = useState({
        remark: false,
    });
    const [statusWork, setStatusWork] = useState([])
    const [workDone, setWorkDone] = useState([])
    const [feedback, setFeedback] = useState([])
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [hasSearched, setHasSearched] = useState(false);

    // Remove initial getTodayVisits call on mount
    // useEffect(() => {
    //     getTodayVisits();
    // }, [paginationModel.page, paginationModel.pageSize, newOrderStatus]);

    // Only call getTodayVisits after first search (Find button click)
    useEffect(() => {
        if (hasSearched) {
            getTodayVisits();
        }
    }, [paginationModel.page, paginationModel.pageSize, newOrderStatus]);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        // getStatusOfVisit();
        // getWorkDone();
        // getFeedback();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    const getStatusOfVisit = async () => {
        try {
            const results = await window.Platform.database.getStatusType({});
            setStatusWork(results.data)
        }
        catch (err) {
            console.log(err)
        }
    }

    const getWorkDone = async () => {
        let results = await window.Platform.database.getWorkDone();
        setWorkDone(results.data)
    }
    const getFeedback = async () => {
        let results = await window.Platform.database.getFeedback();
        setFeedback(results.data)
    }

    const exportOrders = async () => {
        setLoading(true);
        try {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const todayStr = `${yyyy}-${mm}-${dd}`;


            let data = {
                // asm: asm,
                // rsm: rsm,
                asm: userData?.role === 'asm' ? userData?.id : asm,
                rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                ownerName: rm,
                startDate: todayStr,
                endDate: todayStr,
            }
            let result = await window.Platform.database.exportData("/routePlan/downloadRouteplanExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${formattedDate}_Route_Plan_Report.xlsx`);
            // link.setAttribute("download", "visit.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    async function getUsers(role, id) {
        setLoading(true);
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
            setLoading(false);
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
            setLoading(false);
        }
    }

    const getTodayVisits = async () => {
        try {
            setLoading(true);
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const todayStr = `${yyyy}-${mm}-${dd}`;

            let payload = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                status: newOrderStatus,
                startDate: todayStr,
                endDate: todayStr,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,

            };
            let results = await window.Platform.database.getRoutePlan(payload);
            if (results?.status === false) {
                setRowCount(results.data1 || 0);
                const jsonArrayWithId = (results?.data || []).map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessChanges(jsonArrayWithId);
            } else {
                window.NotificationUtils.showError("Error Fetching Data");
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
        } finally {
            setLoading(false);
        }
    };

    const handleOpenVisitModal = async (rowData) => {
        setLoading(true);
        try {
            const result = await window.Platform.database.fetchVisitById({ visitId: rowData.visitId });
            if (result?.status === false && result.data) {
                setVisitModalData(result.data);
                setOpenVisitViewModal(true);
                getQuestionCategory();
            } else {
                window.NotificationUtils.showError("Could not fetch visit details");
            }
        } catch (error) {
            window.NotificationUtils.showError("Error fetching visit details");
        } finally {
            setLoading(false);
        }
    };

    const getQuestionCategory = async () => {
        try {
            setLoading(true);
            let result = await window.Platform.database.getQuestionCategory({});
            if (result?.status && Array.isArray(result.data)) {
                setQuestionCategories(result.data);
            }
            console.log("Question categories:", result);
        } catch (error) {
            console.error("Error fetching question categories", error);
            window.NotificationUtils.showError("Error fetching question categories");
        } finally {
            setLoading(false);
        }
    };

    const handleCloseVisitViewModal = () => {
        setOpenVisitViewModal(false);
        setVisitModalData({})
    };

    const showImages = (pictures) => {
        const url = window.Platform.database.funcForBaseURL() + "/file" + pictures;
        setImageUrl(url);
        setImageModalOpen(true);
    }
    const endVisitDirect = async (rowData) => {
        console.log("Row data for end visit:", rowData);
        setEndVisitRow(rowData);
        setEndVisitForm({
            startMeetingTime: rowData?.start_time_meeting || "",
            endMeetingTime: rowData?.end_time_meeting || "",
            endVisitTime: rowData?.endTime || "",
            remark: "",
            mobileNumber: "",
            contactName: "",
            statusOfVisit: "",
            workDone: "",
            productCategory: [],
            feedback: ""
        });
        setEndVisitModalOpen(true);
        getTodayVisits();
    }
    const openPackaging = (val) => {
        const url = window.Platform.database.funcForBaseURL() + "/file" + val;
        setImageUrl(url);
        setImageModalOpen(true);
    };


    const handleEndVisitSubmit = async () => {

        if (!endVisitForm.remark.trim()) {
            setErrors({ remark: true });
            return;
        }

        const payload = {
            ...endVisitForm,
            visitId: endVisitRow?.visitId
        };

        console.log("Payload to submit:", payload);
        const result = await window.Platform.database.endVisitByWeb(payload);
        if (result?.status) {
            window.NotificationUtils.showError("Something went wrong!");

        }
        else {
            setEndVisitModalOpen(false);
            window.NotificationUtils.showSuccess(result?.message);
            setEndVisitForm({
                startMeetingTime: "",
                endMeetingTime: "",
                endVisitTime: "",
                remark: "",
                mobileNumber: "",
                contactName: "",
                statusOfVisit: "",
                workDone: "",
                productCategory: [],
                feedback: ""
            });
            setErrors({ remark: false });
            getTodayVisits();
        }
    };

    const handleEndVisitFormChange = (e) => {
        const { name, value } = e.target;
        setEndVisitForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleStartMeetingChange = (newValue) => {
        setEndVisitForm((prev) => ({
            ...prev,
            startMeetingTime: newValue ? newValue.toISOString() : "",
        }));
    };

    // const getRouteplanById = async (val, val1, ownerId) => {
    //     try {
    //         setLoading(true)
    //         setModalData()
    //         let sentData = { id: val }
    //         let results = await window.Platform.database.getRouteplanById(sentData);
    //         const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

    //         setModalData({ data: jsonArrayWithId, id: val, date: val1, ownerId: ownerId })
    //         setModal(true)
    //         setLoading(false)
    //     }
    //     catch (error) {
    //         console.log(error)
    //         window.NotificationUtils.showError("Something Went Wrong!")
    //         setLoading(false)
    //     }
    // }


    const getRouteplanById = async (val, val1, ownerId) => {
        try {
            setLoading(true)
            setModalData()
            let sentData = { id: val }
            let results = await window.Platform.database.getRouteplanById(sentData);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

            setModalData({ data: jsonArrayWithId, id: val, date: val1, ownerId: ownerId })
            setModal(true)
            setLoading(false)
        }
        catch (error) {
            console.log(error)
            window.NotificationUtils.showError("Something Went Wrong!")
            setLoading(false)
        }
    }

    const handleConfirmReject = () => {
        if (reason.trim() === "") {
            window.NotificationUtils.showError("Remark is required to reject the order.")
            return;
        }
        approveRejectOrder({ ...rejectData, approvalStatus: "2", reason });
        setOpenDialog(false);
        setReason("");
        setRejectData(null);
    };

    const approveRejectOrder = async (val) => {
        try {
            let message = val.approvalStatus == "1" ? "Route plan approved successfully" : "Route plan rejected successfully";
            setLoading(true);
            let payload = {
                id: val?.id,
                approvalStatus: val?.approvalStatus,
                isDirectApproval: true,
                reason: val?.reason
            }
            // console.log(val, "valllllllllll", payload,"paylaodaddddddddddddddd");
            // return;
            const results = await window.Platform.database.approvePartialRouteNotification(payload)
            if (results.status) {
                window.NotificationUtils.showError(results.message);
                setLoading(false)
                return;
            }
            window.NotificationUtils.showSuccess(message);
            setLoading(false)
            getTodayVisits()
        }
        catch (err) {
            console.log(err)
            window.NotificationUtils.showError("Something Went Wrong!")
            setLoading(false)
        }
    }

    const renderContent1 = () => {
        return (
            <>
                {/* <Stack direction={"row"} spacing={2} padding={2}> */}

                <div className="row mt-2 mb-2 ml-2">

                    <Button
                        onClick={() => {setNewOrderStatus(""); setHasSearched(true)}}
                        style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", fontWeight: "500", }}>
                        All
                    </Button>
                    <Button
                        onClick={() => {setNewOrderStatus(0); setHasSearched(true)}}
                        style={{ backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white", color: newOrderStatus === 0 ? "white" : "black", fontWeight: "500", }}>
                        Pending
                    </Button>
                    <Button
                        onClick={() => {setNewOrderStatus(1); setHasSearched(true)}}
                        style={{ backgroundColor: newOrderStatus === 1 ? "green" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
                        Approved
                    </Button>
                    <Button
                        onClick={() => {setNewOrderStatus(2); setHasSearched(true)}}
                        style={{ backgroundColor: newOrderStatus === 2 ? "red" : "white", color: newOrderStatus === 2 ? "white" : "black", fontWeight: "500", }}>
                        Rejected
                    </Button>
                    <Button
                        onClick={() => {setNewOrderStatus(3); setHasSearched(true)}}
                        style={{ backgroundColor: newOrderStatus === 3 ? "#cddc39" : "white", color: newOrderStatus === 3 ? "black" : "black", fontWeight: "500", }}>
                        Partially Approved
                    </Button>

                    <Typography variant="body1" className="ml-4 mt-2" sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>Select Page Size:&nbsp; </Typography>
                    <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                        sx={{ width: 90, fontSize: "14px", fontWeight: "500", color: "black" }}
                    >
                        {[10, 20, 30, 50, 100].map((role) => (
                            <MenuItem key={role} value={role} sx={{ fontSize: "14px", fontWeight: "500", color: "black" }}>{role}</MenuItem>
                        ))}
                    </Select>
                </div>

                {/* </Stack> */}
                <Stack direction={"column"} spacing={2} padding={0} width={"100%"}>

                    {(!dataGrid || dataGrid.length === 0) ? (
                        <Typography align="center" color="text.secondary" sx={{ py: 5 }}>
                            <b style={{ fontSize: "14px", color: "black", fontWeight: "500" }}>No data found</b>
                        </Typography>
                    )
                        : (
                            <DataGrid
                                className="payrollGrid"
                                style={{ height: !dataGrid.length ? '200px' : 'auto' }}
                                density="compact"
                                rows={dataGrid || []}
                                columns={getColumns()}
                                sx={{ color: "black", fontSize: "12px", fontWeight: "600" }}
                                rowHeight={60}
                                disableSelectionOnClick
                                disableRowSelectionOnClick
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                rowCount={rowCount}
                                paginationModel={paginationModel}
                                paginationMode="server"
                                onPaginationModelChange={setPaginationModel}
                            />
                        )}
                </Stack>
            </>
        )
    }

    useEffect(() => {
        setDataGrid(accessChanges.map((row, idx) => ({
            id: row.visitId || idx + 1,
            name: row.name,
            taggedUserName: row.taggedUserName,
            date: row.date,
            createdAt: row.createdAt,
            status: row.status,
            actionBy: row.actionBy,
            routeId: row.routeId,
            ownerId: row.ownerId,
            tagged_id: row.tagged_id,
        })));
    }, [accessChanges]);


    const formatTimeStamp = (timestampFromDB) => {
        const options = {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,  // Use 12-hour clock
        };
        const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);

        return formattedDate;
    };

    const formatToOnlyDate = (val) => {
        const concertDate = new Date(val);
        const year = concertDate.getFullYear();
        const month = concertDate.getMonth() + 1; // Months are zero-indexed, so we add 1
        const day = concertDate.getDate();
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
        return formattedDate;
    }

    const editData = async (data) => {
        setEditModalData(data)
        setEditMode(true)
        // setAddModal(true)
        try {
            let results = await window.Platform.database.getRouteplanById({ id: data?.routeId });

            if (results.status == false) {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
                setPartyList(jsonArrayWithId)
            }
            else {
                console.log("results=======", results);
                window.NotificationUtils.showError("Something Went Wrong!")
            }
        }
        catch (error) {
            console.log(error)
            window.NotificationUtils.showError("Something Went Wrong!")
        }
    }

    const getColumns = () => {
        const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
        return [
            {
                field: "name",
                headerName: "RM Name",
                sortable: false,
                width: 190,
                filterOperators: stringOperators,
                editable: false,
                valueGetter: (params) => {
                    if (!params.row?.name) return "N/A";
                    return params.row.name.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(" ");
                },
                renderCell: (params) => {
                    let name = "N/A";
                    if (params.row?.name) {
                        name = params.row.name.split(" ")
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(" ");
                    }
                    return (
                        <Tooltip title={name}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "taggedUserName",
                headerName: "Tagged Colleague",
                sortable: false,
                width: 180,
                filterOperators: stringOperators,
                editable: false,
                valueGetter: (params) => {
                    return (params.row?.taggedUserName || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.taggedUserName || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "date",
                headerName: "Route Date",
                width: 110, filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    return (params.row?.date ? formatToOnlyDate(params.row?.date) : "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.date && formatToOnlyDate(params.row?.date) || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "createdAt",
                headerName: "Created At",
                width: 240,
                sortable: false,
                filterable: false,
                valueGetter: (params) => {
                    return (params.row?.createdAt ? formatTimeStamp(params.row?.createdAt) : "N/A");
                },
                renderCell: (params) => {
                    let name = formatTimeStamp(params.row.createdAt) || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "approvalStatus",
                headerName: "Status",
                width: 100, filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    return (params.row?.status === 0 ? "Pending" : params.row?.status === 1 ? "Approved" : params.row?.status === 1 ? "Rejected" : "Partially Approved" || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.status === 0 ? "Pending" : params.row?.status === 1 ? "Approved" : params.row?.status === 1 ? "Rejected" : "Partially Approved" || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "approvedBy",
                headerName: "Action taken By",
                width: 190, filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    return (params.row?.actionBy?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                        .join(" ") || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.actionBy?.split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
                        .join(" ") || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "Approve Order",
                headerName: "Actions",
                width: 130, filterable: false,
                sortable: false,
                disableExport: true,
                renderCell: (params) => {
                    let value = params.row?.routeId
                    let value1 = formatToOnlyDate(params.row?.date)
                    let ownerId = params.row?.ownerId
                    return (
                        <Stack direction={"row"} spacing={0}>
                            <Tooltip title="Click to view party in route-plan"><IconButton variant="extended" color="primary" onClick={(e) => {
                                e.stopPropagation();
                                getRouteplanById(value, value1, ownerId);
                                // viewRoutePlanModal(params.row?.routeId);
                            }} >
                                <RemoveRedEyeIcon />
                            </IconButton></Tooltip>
                            { ( newOrderStatus == "0" ) && <Tooltip title="Click to approve route-plan"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                                e.stopPropagation();
                                approveRejectOrder({ id: value, approvalStatus: "1" });
                            }} >
                                <ThumbUpIcon />
                            </IconButton></Tooltip>
                }
                            {/* <Tooltip title="Click to reject route-plan"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "red" }}
                         // onClick={(e) => {
                         //   e.stopPropagation();
                         //   approveRejectOrder({ id: value, approvalStatus: "2" });
                         // }} 
                         onClick={(e) => { e.stopPropagation(); handleReject({ id: value }); }}>
                         <ThumbDownIcon />
                       </IconButton></Tooltip> */}
                            <Tooltip title="Click to edit route-plan"><IconButton variant="extended" onClick={(e) => { editData(params.row); }}>
                                <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
                            </IconButton></Tooltip>
                        </Stack>
                    )
                },
            },
        ];
    };

    return (
        <>
            <Dialog disableEnforceFocus maxWidth="xl" fullWidth={true} open={true} >
                {loading && <OpaqueLoading />}
                <ModalHeaderContainer style={{ marginBottom: 0, paddingBottom: 1 }}>
                    <Typography variant={isMobile ? "h6" : "h5"} style={{ fontWeight: "500", color: "black" }}>
                        Today's Route Plan (
                        <span style={{ fontSize: isMobile ? 14 : 16, marginLeft: 12 }}>
                            {new Date().toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                            })}
                        </span> )
                        <Tooltip title="Order Id"></Tooltip>
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        <StyledTabs
                            variant="fullWidth"
                            value={tabValue}
                            // onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab label="Today's Route Plan " sx={{ fontSize: "14px" }} />
                        </StyledTabs>
                        <div className="row mb-2 mt-2">
                            {/* {userData?.role.includes('admin') && <div className="col-md-3">
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                    <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: "500" }}>
                                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                        {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </div>} */}
                            {userData?.role.includes('admin') && (
                                <div className="col-md-3">
                                    <Autocomplete
                                        options={rsms}
                                        // getOptionLabel={(option) => option.name || ""}
                                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                        value={rsms.find((role) => role.id === rsm) || null}
                                        onChange={(event, value) => {
                                            setRsm(value ? value.id : "");
                                            setAsm("");
                                            setRm("");
                                            getUsers('rsm', value ? value.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                placeholder="Select HO"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                                                }}
                                                InputLabelProps={{
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                                                }}
                                            />
                                        )}
                                        slotProps={{
                                            paper: {
                                                sx: { color: "black" }
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: '100%', fontSize: 14 }}
                                    />
                                </div>
                            )}
                            {/* {userData?.role != 'asm' && <div className="col-md-3">
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                    <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }} sx={{ width: '100%', fontSize: 14, fontWeight: '500' }}>
                                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                        {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </div>} */}
                            {userData?.role !== 'asm' && (
                                <div className="col-md-3">
                                    <Autocomplete
                                        options={asms}
                                        getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                        // getOptionLabel={(option) => option.name || ""}
                                        value={asms.find((role) => role.id === asm) || null}
                                        onChange={(event, value) => {
                                            setAsm(value ? value.id : "");
                                            setRm("");
                                            getUsers('asm', value ? value.id : "");
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                placeholder="Select ARM"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                                                }}
                                                InputLabelProps={{
                                                    style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                                                }}
                                            />
                                        )}
                                        slotProps={{
                                            paper: {
                                                sx: { color: "black" }
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        sx={{ width: '100%', fontSize: 14 }}
                                    />
                                </div>
                            )}
                            {/* <div className="col-md-2">
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM</InputLabel>
                                    <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                                        {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name}</MenuItem>))}
                                    </Select>
                                </FormControl>
                            </div> */}
                            <div className="col-md-2">
                                <Autocomplete
                                    options={rms}
                                    getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                                    // getOptionLabel={(option) => option.name || ""}
                                    value={rms.find((role) => role.id === rm) || null}
                                    onChange={(event, value) => {
                                        setRm(value ? value.id : "");
                                        // getUsers('rm', value ? value.id : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Select RM"
                                            InputProps={{
                                                ...params.InputProps,
                                                style: { color: "black", fontWeight: 500 }, // <-- This styles the input text
                                            }}
                                            InputLabelProps={{
                                                style: { color: "black", fontWeight: 500 }, // <-- This styles the label
                                            }}
                                        />
                                    )}
                                    slotProps={{
                                        paper: {
                                            sx: { color: "black" }
                                        }
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    sx={{ width: '100%', fontSize: 14, color: "black" }}
                                />
                            </div>
                            <div className="col-md-2">
                                <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); getTodayVisits(); }}>
                                    Find
                                </Button>
                            </div>
                           {is_download && <div className="col-md-2">
                                <Button variant="contained" color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportOrders()}>
                                    Download
                                </Button>
                            </div>}
                        </div>
                        {renderContent1()}
                        {/* {tabValue == 0 && renderContent1()} */}
                    </TabsContainer>
                </TableContainer>
            </Dialog>

            <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="md">
                <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", p: 2, position: "relative" }}>
                    <IconButton aria-label="close" onClick={() => setImageModalOpen(false)} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}>
                        <CloseIcon />
                    </IconButton>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200, minWidth: 200, }}>
                        <img src={imageUrl} alt="Attendance" style={{ maxWidth: "100%", maxHeight: "70vh", height: "auto", width: "auto", borderRadius: 8, display: "block", margin: "0 auto" }} />
                    </Box>
                </DialogContent>
            </Dialog>

            <Dialog open={endVisitModalOpen} onClose={() => { setEndVisitModalOpen(false); }} maxWidth="md" fullWidth >
                <DialogContent>
                    <Typography variant="h6" gutterBottom sx={{ color: "black" }}>End Visit Details</Typography>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <div className="row">
                            <div className="col-md-6">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: '100%', color: "black", fontSize: "14px", fontWeight: "500" }}
                                        label="Start Visit Time"
                                        value={endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : null}
                                        disabled
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-6">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: '100%' }}
                                        label="Start Meeting Time"
                                        value={
                                            endVisitRow?.start_time_meeting
                                                ? dayjs(endVisitRow.start_time_meeting)
                                                : (endVisitForm.startMeetingTime ? dayjs(endVisitForm.startMeetingTime) : null)
                                        }
                                        onChange={handleStartMeetingChange}
                                        minDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined}
                                        maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                                        shouldDisableDate={date =>
                                            endVisitRow?.startTime
                                                ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                                                : false
                                        }
                                        disabled={!!endVisitRow?.start_time_meeting}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: '100%' }}
                                        label="End Meeting Time"
                                        value={
                                            endVisitRow?.end_time_meeting
                                                ? dayjs(endVisitRow.end_time_meeting)
                                                : (endVisitForm.endMeetingTime ? dayjs(endVisitForm.endMeetingTime) : null)
                                        }
                                        onChange={newValue =>
                                            setEndVisitForm(prev => ({
                                                ...prev,
                                                endMeetingTime: newValue ? newValue.toISOString() : "",
                                            }))
                                        }
                                        minDateTime={
                                            endVisitForm.startMeetingTime
                                                ? dayjs(endVisitForm.startMeetingTime)
                                                : (endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined)
                                        }
                                        maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                                        shouldDisableDate={date =>
                                            endVisitRow?.startTime
                                                ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                                                : false
                                        }
                                        disabled={!!endVisitRow?.end_time_meeting}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-6">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: '100%' }}
                                        label="End Visit Time"
                                        value={
                                            endVisitRow?.endTime
                                                ? dayjs(endVisitRow.endTime)
                                                : (endVisitForm.endVisitTime ? dayjs(endVisitForm.endVisitTime) : null)
                                        }
                                        onChange={newValue =>
                                            setEndVisitForm(prev => ({
                                                ...prev,
                                                endVisitTime: newValue ? newValue.toISOString() : "",
                                            }))
                                        }
                                        minDateTime={
                                            endVisitForm.endMeetingTime
                                                ? dayjs(endVisitForm.endMeetingTime)
                                                : (endVisitForm.startMeetingTime
                                                    ? dayjs(endVisitForm.startMeetingTime)
                                                    : (endVisitRow?.startTime ? dayjs(endVisitRow.startTime) : undefined))
                                        }
                                        maxDateTime={endVisitRow?.startTime ? dayjs(endVisitRow.startTime).endOf('day') : undefined}
                                        shouldDisableDate={date =>
                                            endVisitRow?.startTime
                                                ? !dayjs(date).isSame(dayjs(endVisitRow.startTime), 'day')
                                                : false
                                        }
                                        disabled={!!endVisitRow?.endTime}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <TextField
                                    label="Remark"
                                    name="remark"
                                    value={endVisitForm.remark}
                                    onChange={(e) => {
                                        handleEndVisitFormChange(e);
                                        if (errors.remark && e.target.value.trim()) {
                                            setErrors(prev => ({ ...prev, remark: false }));
                                        }
                                    }}
                                    fullWidth
                                    error={errors.remark}
                                    helperText={errors.remark ? "Remark is required." : ""}
                                />

                            </div>
                            <div className="col-md-6">
                                <TextField
                                    label="Mobile Number"
                                    name="mobileNumber"
                                    value={endVisitForm.mobileNumber}
                                    onChange={handleEndVisitFormChange}
                                    fullWidth
                                    type="number"
                                    onWheel={(e) => e.target.blur()} // 👈 prevents scroll wheel increment/decrement
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*',
                                    }}
                                />

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <TextField
                                    label="Contact Name"
                                    name="contactName"
                                    value={endVisitForm.contactName}
                                    onChange={handleEndVisitFormChange}
                                    fullWidth
                                />
                            </div>
                            <div className="col-md-6">
                                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                                    <InputLabel id="status-of-visit-label">Status Of Visit</InputLabel>
                                    <Select
                                        labelId="status-of-visit-label"
                                        id="status-of-visit"
                                        name="statusOfVisit"
                                        value={endVisitForm.statusOfVisit}
                                        onChange={handleEndVisitFormChange}
                                        label="Status Of Visit"
                                    >
                                        {statusWork?.map((option) => (
                                            <MenuItem key={option.statusTypeId} value={option.statusTypeId}>
                                                {option.statusTypeName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                                    <InputLabel id="work-done" >Work Done</InputLabel>
                                    <Select
                                        label="Work Done"
                                        labelId="work-done"
                                        id="work-done"
                                        name="workDone"
                                        value={endVisitForm.workDone}
                                        onChange={handleEndVisitFormChange}
                                    >
                                        {workDone?.map((option, optionIndex) => (
                                            <MenuItem key={option.workDoneTableId} value={option.workDoneTableId}>
                                                {option.workDoneName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl></div>
                            <div className="col-md-6">
                                <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                                    <InputLabel id="feedback-label">Feedback</InputLabel>
                                    <Select
                                        labelId="feedback-label"
                                        id="feedback"
                                        name="feedback"
                                        value={endVisitForm.feedback}
                                        onChange={handleEndVisitFormChange}
                                        label="Feedback"
                                    >
                                        {feedback?.map((option) => (
                                            <MenuItem key={option.feedbackId} value={option.feedbackId}>
                                                {option.feedbackName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>

                        <Box display="flex" justifyContent="flex-end" gap={2}>
                            <Button onClick={() => setEndVisitModalOpen(false)} variant="outlined">Cancel</Button>
                            <Button variant="contained" onClick={handleEndVisitSubmit}>Submit</Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
                <DialogTitle>Reject Route Plan</DialogTitle>
                <DialogContent>
                    <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmReject} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {
                editMode && <AddRoutePlan onClose={() => setEditMode(false)} fetchData={() => getTodayVisits()} editMode={editMode} editModalData={editModalData} partyList={partyList} />
            }

            {
                modal && <PartyList
                    onCancel={() => { setModal(false); getTodayVisits(); }}
                    loading={loading}
                    data={modalData}
                    routeId={modalData?.id}
                    routeDate={modalData?.date}
                    ownerId={modalData?.ownerId}
                    getRouteplanById={getRouteplanById} />
            }
        </>
    );
};
export default TodayRoutePlanModal;